import {useCallback, useContext, useEffect, useState} from "react";
import MemoManager, {MemoState} from "../MemoManager";
import {GameHint} from "./GameHint";
import Footer from "../../Shared/Components/Footer";
import {QuizPlayProps} from "./QuizPlay";
import {MemoCardView} from "./MemoCardView";
import {QuizQuestion} from "./QuizQuestion";
import {NextButton} from "../../Shared/Components/NextButton";
import Score from "../../Shared/Components/Score";
import ThemeContext from "../../Shared/Theme/ThemeContext";
import StringFactory from "../Factory/StringFactory";
import useSound from "use-sound";

export function QuizPlayMemo(props: QuizPlayProps) {
    const [manager,] = useState<MemoManager>(() => new MemoManager(props.quiz, props.settings))
    const [state, setState] = useState<MemoState>(manager.state())
    const update = useCallback(() => setState(manager.state()), [manager])
    const theme = useContext(ThemeContext)
    const [soundGood] = useSound("sounds/good.mp3");

    useEffect(() => () => manager.destroy(), [manager])
    manager.onUpdate = update

    return <div className="quiz-play memo-play" style={{backgroundImage:'url('+theme.backgroundImage+')'}}>
        <h1>{StringFactory.quizTitle(props.quiz, props.settings)}</h1>
        <GameHint text={manager.hint()}/>
        <div className="wrapper">
            <div className="quiz-content">
                <div className="memo">
                    {state.cards.map((c, i) => <MemoCardView key={i}
                        card={c}
                        onSelect={() => { manager.select(i); if (manager.currentQuestion() !== undefined) soundGood(); } }
                    />)}
                </div>
                {manager.currentQuestion() !== undefined && <QuizQuestion question={manager.currentQuestion()} title={true} />}
            </div>
            {manager.shouldDisplayNext() && <NextButton onClick={() => {
                manager.next() ? update() : props.onFinish(manager.score())
            }}/>}
        </div>
        <Score data={manager.score()}/>
        <Footer home={props.onCancel}/>
    </div>
}



